import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo.js';

import '../../styles/common/Header.css';
import logo from '../../assets/homepage/logo.svg';

function Header() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    return (
        <header className="header">
            <Link to="/" className="header__logo">
                {/* <img src={logo} alt="Логотип" className="header__logo-img" /> */}
                <Logo className="header__logo-img" />
            </Link>

            <button 
                className={`header__burger ${isOpen ? 'header__burger--active' : ''}`} 
                onClick={toggleMenu}
                aria-label="Меню"
            >
                <span className="header__burger-line"></span>
                <span className="header__burger-line"></span>
                <span className="header__burger-line"></span>
            </button>

            <nav className={`header__menu ${isOpen ? 'header__menu--open' : ''}`}>
                <Link to="/teachers" className="header__link" onClick={closeMenu}>
                    Вчителям
                </Link>
                <Link to="/parents" className="header__link" onClick={closeMenu}>
                    Батькам
                </Link>
                <Link
                    to="/theme/fractions"
                    onClick={closeMenu}
                    className="header__link header__link--highlighted"
                >
                    Мерщій вчитися
                </Link>
            </nav>
        </header>
    );
}

export default Header;